import * as React from 'react';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Tree } from 'primereact/tree';

const LogFilesView = (props) => {
  return (
    <div>
      <Tree
        style={{ width: "100%" }}
        selectionMode="single"
        value={props.treeLogNodes}
        selectionKeys={props.selectionKeys}
        onSelectionChange={e => props.handleSelectionChange(e.value)}
        onContextMenu={props.onContextMenu}
      />
    </div>
  )
}

export default LogFilesView;
